module.exports = __webpack_public_path__ + "media/images/svg/push-your-limits-74457e33267861e150648cf075f36578.svg";